
/**
 * 时间格式化函数
 * @param {原始时间} orignVal
 */
export function dateFormat (orignVal) {
  const dt = new Date(orignVal)
  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')

  return `${y}-${m}-${d}`
}

export function dateFormatYMDHMS (orignVal) {
  const dt = new Date(orignVal)
  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')

  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')

  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
}

export function getMonthStart () {
  var now = new Date() // 当前日期
  var nowMonth = now.getMonth() // 当前月
  var nowYear = now.getFullYear() // 当前年
  return new Date(nowYear, nowMonth, 1)// 本月的开始时间
}

export function getMonthEnd () {
  var now = new Date() // 当前日期
  var nowMonth = now.getMonth() // 当前月
  var nowYear = now.getFullYear() // 当前年
  return new Date(nowYear, nowMonth + 1, 0)// 本月的结束时间
}

// 将时间转换为整数，忽略秒数
export function parseTimeToMinute (timeStr) {
  const timeArr = (timeStr + '').split(':')
  var result = '0'
  if (timeArr.length >= 2) {
    result = parseInt(timeArr[0]) * 60 + parseInt(timeArr[1])
  } else {
    result = parseInt(timeArr[0]) * 60
  }
  return result
}

// 将分钟数转换为时间
export function parseMinuteToTime (timeStr) {
  let result = ''
  if ((timeStr / 60) > 9) {
    if (timeStr % 60 === 0) {
      result = timeStr / 60 + ':' + '00'
    } else {
      result = timeStr / 60 + ':' + timeStr % 60
    }
  } else {
    if (timeStr % 60 === 0) {
      result = '0' + timeStr / 60 + ':' + '00'
    } else {
      result = '0' + timeStr / 60 + ':' + timeStr % 60
    }
  }
  return result + ':00'
}
